import React, { useState, useEffect } from 'react';
import { LoadingButton } from '@one-thd/sui-atomic-components';
import { executePrintShippingLabel } from '../../utils/printReturnLabelUtil';
import PrintLabelAlerts from './PrintLabelAlerts';
import { useSummaryStore } from '../../stores/summaryStore';
import { useReturnStore } from '../../stores/returnStore';
export var PrintReturnLabel = function (_a) {
    var isNativeApp = _a.isNativeApp;
    var _b = useSummaryStore(function (state) { return state; }), orderId = _b.orderId, emailId = _b.emailId, _c = _b.returnTrackingNumbers, returnTrackingNumbers = _c === void 0 ? [] : _c, trackingDetails = _b.trackingDetails;
    var orderDetailsV2 = useReturnStore(function (state) { return state.orderDetailsV2; });
    var militaryExchange = useReturnStore(function (state) { return state.militaryExchange; });
    var isMilitaryExchangeGuest = useReturnStore(function (state) { return state.isMilitaryExchangeGuest; });
    var _d = useState(false), isLoading = _d[0], setIsLoading = _d[1];
    var _e = useState(), apiError = _e[0], setAPIError = _e[1];
    var _f = useState(true), retryAvailable = _f[0], setRetryAvailable = _f[1];
    // eslint-disable-next-line consistent-return
    useEffect(function () {
        if (apiError === null || apiError === void 0 ? void 0 : apiError.retryable) {
            var timeoutId_1 = setTimeout(function () {
                setRetryAvailable(true);
            }, 1000);
            return function () { return clearTimeout(timeoutId_1); };
        }
    }, [apiError === null || apiError === void 0 ? void 0 : apiError.retryable, retryAvailable]);
    var onButtonClick = function () {
        var params = {
            trackingDetails: trackingDetails,
            orderId: orderId,
            emailId: emailId,
            isMilitaryExchangeGuest: isMilitaryExchangeGuest,
            orderDetailsV2: orderDetailsV2,
            returnTrackingNumbers: returnTrackingNumbers,
        };
        var callbacks = {
            setIsLoading: setIsLoading,
            setAPIError: setAPIError,
            setRetryAvailable: setRetryAvailable,
        };
        executePrintShippingLabel(params, isNativeApp, militaryExchange, callbacks);
    };
    return (React.createElement("div", { className: "sm:sui-ml-6  sui-mb-6" },
        apiError && React.createElement(PrintLabelAlerts, { error: apiError }),
        React.createElement(LoadingButton, { loading: isLoading, onClick: onButtonClick, variant: "primary", disabled: !retryAvailable },
            React.createElement("span", null, "Print Free Return Label"))));
};
export default PrintReturnLabel;
